import { __assign, __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { getShowString } from '../../util';
export var getDeptItemsByIds = function (ids) {
    if (ids === void 0) { ids = []; }
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var departmentData, departmentMap;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!ids.length) {
                        return [2, []];
                    }
                    return [4, app.dataLoader('@common.department').load()];
                case 1:
                    departmentData = _b.sent();
                    departmentMap = (_a = departmentData === null || departmentData === void 0 ? void 0 : departmentData.mapData) !== null && _a !== void 0 ? _a : {};
                    return [2, ids
                            .map(function (id) { return departmentMap[id]; })
                            .filter(Boolean)
                            .map(function (item) { return ({
                            id: item.id,
                            label: getShowString(item, 'department'),
                            type: 'department',
                            showAvatar: false
                        }); })];
            }
        });
    }); };
};
export var getStaffItemByIds = function (ids) {
    if (ids === void 0) { ids = []; }
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var staffs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ids.length) {
                        return [2, []];
                    }
                    return [4, app.dataLoader('@common.staffs').load()];
                case 1:
                    staffs = _a.sent();
                    return [2, staffs.filter(function (line) { return ids.includes(line.id); }).map(function (item) { return formatStaffToTagData(item); })];
            }
        });
    }); };
};
export var getExternalStaffItemByIds = function (ids) {
    if (ids === void 0) { ids = []; }
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var staffs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ids.length) {
                        return [2, []];
                    }
                    return [4, app.dataLoader('@common.externalList').load()];
                case 1:
                    staffs = _a.sent();
                    return [2, staffs.filter(function (line) { return ids.includes(line.id); }).map(function (item) { return formatStaffToTagData(item); })];
            }
        });
    }); };
};
export var formatStaffToTagData = function (staff) {
    if (!staff)
        return staff;
    return __assign(__assign({}, staff), { id: staff.id, label: getShowString(staff, 'staff'), type: 'staff', avatar: staff.avatar, showAvatar: true });
};
export var getRoleItemByIds = function (ids) {
    if (ids === void 0) { ids = []; }
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var roles;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ids.length) {
                        return [2, []];
                    }
                    return [4, app.dataLoader('@common.roleList').load()];
                case 1:
                    roles = _a.sent();
                    return [2, roles
                            .filter(function (line) { return ids.includes(line.id); })
                            .map(function (item) { return ({
                            id: item.id,
                            label: getShowString(item, 'role'),
                            type: 'role',
                            showAvatar: false
                        }); })];
            }
        });
    }); };
};
export var tagLabelLimit = function (tag, tagStrLimit) {
    var _a;
    if (tagStrLimit && ((_a = tag.label) === null || _a === void 0 ? void 0 : _a.length) > tagStrLimit) {
        var str = tag.label.substring(0, tagStrLimit) + "...";
        return { toolTipStr: tag.label, tag: __assign(__assign({}, tag), { label: str }) };
    }
    return { toolTipStr: '', tag: tag };
};
